import { connect } from "react-redux"
import { Button, Card, CardBody, CardHeader, Col, Container, Form, FormInput, FormSelect, Row } from "shards-react"
import InfoTooltip from "../../components/common/InfoTooltip"
import { get_sub_config, set_sub_config } from "../../redux/actions/user"
import { useEffect, useState } from "react"
import { get_compensation_payee_list } from "../../redux/actions/subscriber/payroll"
import { GeneralSettingsKeys } from "../../utils/constants"

function Settings({
    subConfigList,
    get_sub_config,
    set_sub_config,
    compensationPayeeList,
    get_compensation_payee_list
}) {

    const [formData, setFormData] = useState({
        gstHst: '',
        defaultCompensationMethod: '',
        defaultGovernmentTaxRemittance: '',
        defaultBenefitsProvider: '',

        subConfigAllowClientViewInvoice: '',
    })

    const [generalData, setGeneralData] = useState({
        defaultKeyIncomingPayment: '',
        defaultKeyOutgoingPayment: '',
        defaultKeyCreditMemoPayment: '',
        defaultKeyRoundingMethodCalculation: '',
        defaultKeyViewIntermediateCalculation: '',
        crAutoSyncProfileDataToPayitems: 'Yes',
    })

    const [paymentData, setPaymentData] = useState({
        //Tickets keys 
        // piRecipientName: '',
        // piRecipientAddress: '',
        // piBankName: '',
        // piBankAddress: '',
        // piBankAccountNumber: '',

        // Keys to store in json object asked by zellur// encodeURIComponent
        recipientName: '',
        address: '',
        bankName: '',
        bankAddress: '',
        bankAccount: '',
        routing: '',
        instructionsSteps: []
    });

    const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value })
    const onChangeGeneralData = (e) => setGeneralData({ ...generalData, [e.target.name]: e.target.value })
    const onChangePaymentData = (e) => setPaymentData({ ...paymentData, [e.target.name]: e.target.value })
    const payeeListOptions = (compensationPayeeList || []).map(payee => ({ value: payee.refId, label: payee.payeeName }));

    const incomingPayment = ["Payment amount set by user", "Payment amount set by allocation"];
    const outgoingPayment = ["Payment amount set by allocation", "Payment amount set by user"];
    const roundingMethodCalculation = ["Round to two decimal places for total only", "Round to two decimal places for each calculation"];
    const viewIntermediateCalculation = ["Show intermediate calculations to 5 decimal places", "Show intermediate calculations to 2 decimal places"];
    const allowClientViewInvoice = ["No, do not allow clients to view invoices", "Yes, allow clients to view invoices"];
    const changeRequestAutoSyncPayItem = ["Yes", "No"]

    const incomingPaymentOption = incomingPayment.map((x, id) => { return <option key={x + "_" + id} value={x}> {x} </option>});
    const outgoingPaymentOption = outgoingPayment.map((x, id) => { return <option key={x + "_" + id} value={x}> {x} </option>});
    const roundingMethodCalculationOption = roundingMethodCalculation.map((x, id) => { return <option key={x + "_" + id} value={x}> {x} </option>});
    const viewIntermediateCalcOption = viewIntermediateCalculation.map((x, id) => { return <option key={x + "_" + id} value={x}> {x} </option>});
    const allowClientViewInvoiceOption = allowClientViewInvoice.map((x, id) => { return <option key={x + "_" + id} value={x}> {x} </option>});
    const changeRequestAutoSyncPayItemOptions = changeRequestAutoSyncPayItem.map((x, id) => { return <option key={x + "_" + id} value={x}> {x} </option>});

    const onSubmit = (e) => {
        e.preventDefault();
        set_sub_config('gstHst', formData.gstHst)
    }

    const onSubmitCompensationPayment = (e) => {
        e.preventDefault();
        set_sub_config('defaultCompensationMethod', formData.defaultCompensationMethod)
    }

    const onSubmitGovernmentTax = (e) => {
        e.preventDefault();
        set_sub_config('defaultGovernmentTaxRemittance', formData.defaultGovernmentTaxRemittance)
    }

    const onSubmitBenefitProvider = (e) => {
        e.preventDefault();
        set_sub_config('defaultBenefitsProvider', formData.defaultBenefitsProvider)
    }

    const onSubmitAllowClientsToViewInvoice = (e) => {
        e.preventDefault();
        set_sub_config('subConfigAllowClientViewInvoice', formData.subConfigAllowClientViewInvoice === allowClientViewInvoice[1] ? 1 : 0)
    }

    const onSubmitGeneralSettings = (e) => {
        e.preventDefault();
        let userSession = JSON.parse(localStorage.getItem("user"));
        switch(e.nativeEvent.submitter.name){
            case 'defaultKeyIncomingPayment':
                set_sub_config(GeneralSettingsKeys.defaultKeyIncomingPayment, generalData.defaultKeyIncomingPayment)
                userSession[GeneralSettingsKeys.defaultKeyIncomingPayment] = generalData.defaultKeyIncomingPayment;
                break
            case 'defaultKeyOutgoingPayment':
                set_sub_config(GeneralSettingsKeys.defaultKeyOutgoingPayment, generalData.defaultKeyOutgoingPayment)
                userSession[GeneralSettingsKeys.defaultKeyOutgoingPayment] = generalData.defaultKeyOutgoingPayment;
                break
            case 'defaultKeyRoundingMethodCalculation':
                set_sub_config(GeneralSettingsKeys.defaultKeyRoundingMethodCalculation, generalData.defaultKeyRoundingMethodCalculation)
                userSession[GeneralSettingsKeys.defaultKeyRoundingMethodCalculation] = generalData.defaultKeyRoundingMethodCalculation.indexOf('total') > 0 ? 'Total' : 'Each';
                break
            case 'defaultKeyViewIntermediateCalculation':
                set_sub_config(GeneralSettingsKeys.defaultKeyViewIntermediateCalculation, generalData.defaultKeyViewIntermediateCalculation)
                userSession[GeneralSettingsKeys.defaultKeyViewIntermediateCalculation] = generalData.defaultKeyViewIntermediateCalculation.indexOf('2') > 0 ? '2' : '5';
                break
            case 'defaultKeyCreditMemoPayment':
                set_sub_config(GeneralSettingsKeys.defaultKeyCreditMemoPayment, generalData.defaultKeyCreditMemoPayment)
                userSession[GeneralSettingsKeys.defaultKeyCreditMemoPayment] = generalData.defaultKeyCreditMemoPayment;
                break
            case 'crAutoSyncProfileDataToPayitems':
                set_sub_config(GeneralSettingsKeys.crAutoSyncProfileDataToPayitems, generalData.crAutoSyncProfileDataToPayitems)
                userSession[GeneralSettingsKeys.crAutoSyncProfileDataToPayitems] = generalData.crAutoSyncProfileDataToPayitems;
                break

        }
        localStorage.setItem("user", JSON.stringify(userSession));
    }

    const onSubmitPaymentSettings = (e) => {
        e.preventDefault();
        // switch(e.nativeEvent.submitter.name){
        //     case 'recipientName':
        //         set_sub_config("recipientName", paymentData.recipientName)
        //         break
        //     case 'address':
        //         set_sub_config("address", paymentData.address)
        //         break
        //     case 'bankName':
        //         set_sub_config("bankName", paymentData.bankName)
        //         break
        //     case 'bankAddress':
        //         set_sub_config("bankAddress", paymentData.bankAddress)
        //         break
        //     case 'bankAccount':
        //         set_sub_config("bankAccount", paymentData.bankAccount)
        //         break
        // }
        let obj = { recipientName: encodeURIComponent(paymentData.recipientName)
            , address: encodeURIComponent(paymentData.address)
            , bankName: encodeURIComponent(paymentData.bankName)
            , bankAddress: encodeURIComponent(paymentData.bankAddress)
            , bankAccount: encodeURIComponent(paymentData.bankAccount)
        }
        let savingObj = { subConfigBankDetails: JSON.stringify(obj) };
        set_sub_config("subConfigBankDetails", savingObj.subConfigBankDetails);
    }

    useEffect(() => {

        const subConfig = (subConfigList || []).reduce((obj1, obj2) => {
            obj1[obj2.field] = obj2.value;
            return obj1;
        }, {});
        //console.log("sub config =>", subConfig);
        setFormData({ ...formData, ...subConfig
            , subConfigAllowClientViewInvoice: Number(subConfig.subConfigAllowClientViewInvoice) === 1 
                ? allowClientViewInvoice[1] : allowClientViewInvoice[0]  
         })
        
        setGeneralData({ ...generalData, ...subConfig })

        //Need to make around other stuff
        //setPaymentData({ ...paymentData, ...subConfig })
        let bankDetails = subConfig.subConfigBankDetails;
        if(bankDetails !== undefined && bankDetails !== null) {
            let savedObj = JSON.parse(bankDetails);
            setPaymentData({ ...paymentData
                , recipientName: decodeURIComponent(savedObj.recipientName)
                , address: decodeURIComponent(savedObj.address)
                , bankName: decodeURIComponent(savedObj.bankName)
                , bankAddress: decodeURIComponent(savedObj.bankAddress)
                , bankAccount: decodeURIComponent(savedObj.bankAccount)
            })
        }
    }, [subConfigList])

    useEffect(() => {
        get_sub_config();
        get_compensation_payee_list();
    }, [])

    return (
        <div className="position-relative">
            {/* <span className="tableHeader">Default Settings</span> */}
            <Card className="tableCard p-0 border-card">
                <CardBody className="p-4">
                    <Container fluid className="file-manager__filters">
                        <Form onSubmit={onSubmit}>
                            <hr></hr>
                            <Row>
                                <Col>
                                    <label><b> General Settings </b></label>
                                </Col>
                            </Row>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="gstHst" className="p-2">Sales Tax ID</label>
                                    <InfoTooltip infoClass="" cssClassName="text-start mw-100 mb-5" msg="<div>For Canadian Subscribers this is the GST/HST registeration number to be used for invoices.</div>"></InfoTooltip>
                                </Col>
                                <Col lg="4">
                                    <FormInput
                                        name="gstHst"
                                        id="gstHst"
                                        value={formData.gstHst}
                                        placeholder="Enter Sales Tax ID"
                                        onChange={onChange} />
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button>Save</Button>
                                </Col>
                            </Row>
                        </Form>
                        <Form onSubmit={onSubmitCompensationPayment}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="defaultCompensationMethod" className="p-2">Default Compensation Method</label>
                                </Col>
                                <Col lg="4">
                                    <FormSelect size="sm"
                                        name='defaultCompensationMethod' value={formData.defaultCompensationMethod}
                                        className="d-inline" onChange={onChange}
                                    >
                                        <option key={0} value={""}>
                                            Select Default Payment Method
                                        </option>

                                        {payeeListOptions.map((item, idx) => (
                                            <option key={idx} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </FormSelect>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button>Save</Button>
                                </Col>
                            </Row>
                        </Form>
                        <Form onSubmit={onSubmitGovernmentTax}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="defaultGovernmentTaxRemittance" className="p-2">Default Government Tax Remittance</label>
                                </Col>
                                <Col lg="4">
                                    <FormSelect size="sm"
                                        name='defaultGovernmentTaxRemittance' value={formData.defaultGovernmentTaxRemittance}
                                        className="d-inline" onChange={onChange}
                                    >
                                        <option key={0} value={""}>
                                            Select Default Government Tax Remittance
                                        </option>
                                        {payeeListOptions.map((item, idx) => (
                                            <option key={idx} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </FormSelect>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button>Save</Button>
                                </Col>
                            </Row>
                        </Form>
                        <Form onSubmit={onSubmitBenefitProvider}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="defaultBenefitsProvider" className="p-2">Default Benefits Provider</label>
                                </Col>
                                <Col lg="4">
                                    <FormSelect size="sm"
                                        name='defaultBenefitsProvider' value={formData.defaultBenefitsProvider}
                                        className="d-inline" onChange={onChange}
                                    >
                                        <option key={0} value={""}>
                                            Select Default Benefits Provider
                                        </option>
                                        {payeeListOptions.map((item, idx) => (
                                            <option key={idx} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </FormSelect>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button>Save</Button>
                                </Col>
                            </Row>
                        </Form>

                        <Form onSubmit={onSubmitGeneralSettings}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="defaultKeyIncomingPayment" className="p-2">Incoming Payment Behaviour</label>
                                </Col>
                                <Col lg="4">
                                    <FormSelect size="sm"
                                        name='defaultKeyIncomingPayment' value={generalData.defaultKeyIncomingPayment}
                                        className="d-inline" onChange={onChangeGeneralData}
                                    >
                                        <option key={0} value={""}>
                                            Select Incoming Payment Behaviour
                                        </option>
                                        { incomingPaymentOption }
                                    </FormSelect>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button name="defaultKeyIncomingPayment">Save</Button>
                                </Col>
                            </Row>
                        </Form>
                        <Form onSubmit={onSubmitGeneralSettings}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="defaultKeyOutgoingPayment" className="p-2">Outgoing Payment Behaviour</label>
                                </Col>
                                <Col lg="4">
                                    <FormSelect size="sm"
                                        name='defaultKeyOutgoingPayment' value={generalData.defaultKeyOutgoingPayment}
                                        className="d-inline" onChange={onChangeGeneralData}
                                    >
                                        <option key={0} value={""}>
                                            Select Outgoing Payment Behaviour
                                        </option>
                                        { outgoingPaymentOption }
                                    </FormSelect>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button name="defaultKeyOutgoingPayment">Save</Button>
                                </Col>
                            </Row>
                        </Form>

                        <Form onSubmit={onSubmitGeneralSettings}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="defaultKeyCreditMemoPayment" className="p-2">Credit Memo Payment Behaviour</label>
                                </Col>
                                <Col lg="4">
                                    <FormSelect size="sm"
                                        name='defaultKeyCreditMemoPayment' value={generalData.defaultKeyCreditMemoPayment}
                                        className="d-inline" onChange={onChangeGeneralData}
                                    >
                                        <option key={0} value={""}>
                                            Select Credit Memo Payment Behaviour
                                        </option>
                                        { incomingPaymentOption }
                                    </FormSelect>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button name="defaultKeyCreditMemoPayment">Save</Button>
                                </Col>
                            </Row>
                        </Form>

                        <Form onSubmit={onSubmitGeneralSettings}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="defaultKeyRoundingMethodCalculation" className="p-2">Rounding Method of Intermediate Calculations</label>
                                </Col>
                                <Col lg="4">
                                    <FormSelect size="sm"
                                        name='defaultKeyRoundingMethodCalculation' value={generalData.defaultKeyRoundingMethodCalculation}
                                        className="d-inline" onChange={onChangeGeneralData}
                                    >
                                        <option key={0} value={""}>
                                            Select Rounding Method of Intermediate Calculations
                                        </option>
                                        { roundingMethodCalculationOption }
                                    </FormSelect>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button name="defaultKeyRoundingMethodCalculation">Save</Button>
                                </Col>
                            </Row>
                        </Form>
                        <Form onSubmit={onSubmitGeneralSettings}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="defaultKeyViewIntermediateCalculation" className="p-2">Viewing Intermediate Calculations</label>
                                </Col>
                                <Col lg="4">
                                    <FormSelect size="sm"
                                        name='defaultKeyViewIntermediateCalculation' value={generalData.defaultKeyViewIntermediateCalculation}
                                        className="d-inline" onChange={onChangeGeneralData}
                                    >
                                        <option key={0} value={""}>
                                            Select Viewing Intermediate Calculations
                                        </option>
                                        { viewIntermediateCalcOption }
                                    </FormSelect>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button name="defaultKeyViewIntermediateCalculation">Save</Button>
                                </Col>
                            </Row>
                        </Form>

                        <Form onSubmit={onSubmitGeneralSettings}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="crAutoSyncProfileDataToPayitems" className="p-2">
                                        For Change Requests Automatically Sync Profile Data to Pay Items
                                    </label>
                                </Col>
                                <Col lg="4">
                                    <FormSelect size="sm"
                                        name='crAutoSyncProfileDataToPayitems' value={generalData.crAutoSyncProfileDataToPayitems}
                                        className="d-inline" onChange={onChangeGeneralData}
                                    >
                                        { changeRequestAutoSyncPayItemOptions }
                                    </FormSelect>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button name="crAutoSyncProfileDataToPayitems">Save</Button>
                                </Col>
                            </Row>
                        </Form>
                        <hr></hr>
                        <Row>
                            <Col>
                                <label><b> Payment Instructions </b></label>
                            </Col>
                        </Row>
                        <Form onSubmit={onSubmitPaymentSettings}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="recipientName" className="p-2">Recipient Name</label>
                                </Col>
                                <Col lg="4">
                                    <FormInput name='recipientName' value={paymentData.recipientName}
                                        className="d-inline" onChange={onChangePaymentData}>
                                    </FormInput>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button name="recipientName">Save</Button>
                                </Col>
                            </Row>
                        </Form>

                        <Form onSubmit={onSubmitPaymentSettings}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="address" className="p-2">Recipient Address</label>
                                </Col>
                                <Col lg="4">
                                    <FormInput name='address' value={paymentData.address}
                                        className="d-inline" onChange={onChangePaymentData}>
                                    </FormInput>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button name="address">Save</Button>
                                </Col>
                            </Row>
                        </Form>

                        <Form onSubmit={onSubmitPaymentSettings}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="bankName" className="p-2">Bank Name</label>
                                </Col>
                                <Col lg="4">
                                    <FormInput name='bankName' value={paymentData.bankName}
                                        className="d-inline" onChange={onChangePaymentData}>
                                    </FormInput>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button name="bankName">Save</Button>
                                </Col>
                            </Row>
                        </Form>

                        <Form onSubmit={onSubmitPaymentSettings}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="bankAddress" className="p-2">Bank Address</label>
                                </Col>
                                <Col lg="4">
                                    <FormInput name='bankAddress' value={paymentData.bankAddress}
                                        className="d-inline" onChange={onChangePaymentData}>
                                    </FormInput>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button name="bankAddress">Save</Button>
                                </Col>
                            </Row>
                        </Form>

                        <Form onSubmit={onSubmitPaymentSettings}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="bankAccount" className="p-2">Bank Account #</label>
                                </Col>
                                <Col lg="4">
                                    <FormInput name='bankAccount' value={paymentData.bankAccount}
                                        className="d-inline" onChange={onChangePaymentData}>
                                    </FormInput>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button name="bankAccount">Save</Button>
                                </Col>
                            </Row>
                        </Form>

                        <Row>
                            <Col>
                                <label><b> Client Default Settings </b></label>
                            </Col>
                        </Row>
                        <Form onSubmit={onSubmitAllowClientsToViewInvoice}>
                            <Row className="form-group p-2 mb-0">
                                <Col lg="4">
                                    <label for="subConfigAllowClientViewInvoice" className="p-2">Allow Clients to view Invoices</label>
                                </Col>
                                <Col lg="4">
                                    <FormSelect size="sm"
                                        name='subConfigAllowClientViewInvoice' value={formData.subConfigAllowClientViewInvoice}
                                        className="d-inline" onChange={onChange}
                                    >
                                        <option key={0} value={""}>
                                            Select Allow Client to view Invoices
                                        </option>
                                        { allowClientViewInvoiceOption }
                                    </FormSelect>
                                </Col>
                                <Col lg="3" className="pt-1">
                                    <Button>Save</Button>
                                </Col>
                            </Row>
                        </Form>

                    </Container>
                </CardBody>
            </Card>
        </div>
    )
}

const mapStateToProps = (state) => ({
    subConfigList: state.user.subConfigList,
    compensationPayeeList: state.payroll.compensationPayeeList,
})
export default connect(mapStateToProps, {
    get_sub_config,
    set_sub_config,
    get_compensation_payee_list
})(Settings)